module.exports = __webpack_public_path__ + "img/04.e644e018.jpg";